import React from 'react';
import { Checkbox, TableBody, TableCell, TableRow } from '@mui/material';
import { TableBodyProps } from '@mui/material/TableBody';
import { Item, Resource } from '../../../../crud-graphql-containers/Utils/genericTypes';
import { isReactComponent } from '../../../../crud-core/utils/TypescriptUtils';

export interface TableListBodyProps {
  bulkSelectionPossible?: boolean;
  children?: React.ReactNode;
  selected?: string[];
  items: Item[];
  onSelectClick?: (event: React.MouseEvent<HTMLTableRowElement>, id: string) => void;
  resourceConfig?: Resource;
  tableBodyProps?: TableBodyProps;
}

const isSelected = (id: string, selected: string[]): boolean => selected.indexOf(id) !== -1;

const TableListBody: React.FC<TableListBodyProps> = ({
  bulkSelectionPossible = false,
  children,
  selected = [],
  items,
  onSelectClick = () => {
    return;
  },
  tableBodyProps,
  resourceConfig,
}: TableListBodyProps) => {
  const keyProperty = resourceConfig ? resourceConfig.keyProperty : 'id';
  return (
    <TableBody {...tableBodyProps}>
      {items.map((item) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={item[keyProperty]}
            onClick={(event) => onSelectClick(event, item[keyProperty])}
          >
            {bulkSelectionPossible && (
              <TableCell padding="checkbox">
                <Checkbox checked={isSelected(item[keyProperty], selected)} />
              </TableCell>
            )}
            {React.Children.map(children, (field) => {
              if (!field || !isReactComponent(field)) {
                return;
              }

              const { tableCellProps, field: fieldName } = field.props;
              return (
                <TableCell {...tableCellProps}>
                  {React.cloneElement(field, {
                    key: `${fieldName}_${item[keyProperty]}`,
                    item,
                    resourceConfig,
                    ...field.props,
                  })}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

// eslint-disable-next-line import/no-default-export
export default TableListBody;
